import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import PageTitle from '../../components/Common/PageTitle';
import Loading from '../../components/Common/Loading';
import ChallengeTable from '../../components/Tables/ChallengeTable';
import { getChallenge, getActions, getLeaderboard } from '../../actions/challengeActions';
import { submitUserSearchRequest } from '../../actions/userActions';
import ChallengeClientsContainer from '../../containers/Challenges/ChallengeClientsContainer';
import browserHistory from '../../history';

class ChallengeClients extends React.Component {
  componentDidMount() {
    const {
      doGetChallenge,
      doGetLeaderboard,
      search,
      match: {
        params: { challenge_id },
      },
    } = this.props;

    doGetChallenge(challenge_id);
    doGetLeaderboard(challenge_id);
    search({});
  }

  render() {
    const { challenge = {}, clients, leaderboard } = this.props;
    const { id } = challenge;
    return (
      <ContentWrapper>
        <Row>
          <Col xs={12}>
            <PageTitle title="Challenge Participants" />
            <div className="mb-4 mt-n2">
              <Link to={`/challenges/${id}`}>
                <em className="fa-lg mr-2 fas fa-arrow-left" />
                Back to Challenge
              </Link>
            </div>
          </Col>
        </Row>
        {challenge && challenge.name && clients && leaderboard ? (
          <div className="main-content-container">
            <ChallengeClientsContainer challenge={challenge} clients={clients} leaderboard={leaderboard} />
          </div>
        ) : (
          <Loading />
        )}
      </ContentWrapper>
    );
  }
}

ChallengeClients.propTypes = {
  doGetChallenge: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  user: PropTypes.instanceOf(Object),
  // eslint-disable-next-line react/no-unused-prop-types
  team: PropTypes.instanceOf(Object),
  clients: PropTypes.instanceOf(Array),
  // eslint-disable-next-line react/no-unused-prop-types
  doGetActions: PropTypes.func,
  leaderboard: PropTypes.instanceOf(Array),
  doGetLeaderboard: PropTypes.func,
};
const mapStateToProps = (state) => ({
  challenge: state.challenges.challenge,
  user: state.auth.user,
  team: state.team,
  actions: state.challenges.actions,
  leaderboard: state.challenges.leaderboard,
  clients: state.clients.userSearchResults,
});
const mapDispatchToProps = (dispatch) => ({
  doGetChallenge: (challenge_id) => {
    dispatch(getChallenge(challenge_id));
  },
  doGetLeaderboard: (challenge_id) => {
    dispatch(getLeaderboard(challenge_id));
  },
  doGetActions: () => {
    dispatch(getActions());
  },
  search: (values) => {
    dispatch(submitUserSearchRequest(values));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeClients);
